import React, { useContext, useState } from 'react';
import '../styles/MyReviews.css'
import { useNavigate } from 'react-router-dom';
import LocationReviewCardList from '../components/LocationReviewCardList';
import AppContext from '../context/AppContext';
import MyReviewsContent from '../interfaces/MyReviewsContent';
import MyReviewsContext from '../context/MyReviewsContext';


interface MyReviewsProps { }

const MyReviews: React.FC<MyReviewsProps> = () => {
  const navigate = useNavigate();
  const { user } = useContext(AppContext);
  const [refreshReviews, setRefreshReviews] = useState<boolean>(false); 

  const context: MyReviewsContent = {
    refreshReviews,
    setRefreshReviews
  }

  return (
    <MyReviewsContext.Provider value={context}>
      <div className='page-container container'>
        <div className='content-wrap'>
        <button id='return-btn' className='shadowed' onClick={() => navigate('/')}>← Inicio</button>
          <section>
            <h1 className='shadowed' style={{color: 'white'}}>Hola {user.displayName}</h1>
            <LocationReviewCardList specificUser={user}/>  
          </section>
        </div>
      </div>
    </MyReviewsContext.Provider>
  );
};

export default MyReviews;
